import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Axios from "axios";

import { AccountMenu } from "./menu";
import { AccountSettings } from "./account";
import { ClipSettings } from "./clipSettings";
import { Notifications } from "./notifications";
import ConnectedAccounts from "./connectedAccounts";
import { FloatingContainer } from "../../components/wrappers/floatingContainer";
import { FormLink } from "../../components/atoms/form/link";
import { Body } from "../../components/text";
import { FullScreenWrapper } from "../../components/wrappers/fullScreenWrapper";
import { ExternalButton } from "../../components/atoms/form/button/external";
import { FloatingContent } from "../../components/molecules/floatingContent";
import { URLS } from "../../utils";
import { Box, Flex } from "rebass/styled-components";
import theme from "../../theme/themeThree";
import {
  Page,
  MainRail,
  StickySideRail,
} from "../../components/wrappers/contentRails";
import { useMediaQuery } from "../../hooks";
import { useTrackUnsavedChanges } from "MVVM/Hooks/useTrackUnsavedChanges";
import { useUser } from "../../MVVM/Hooks/useUser";
import { useIsDesktopApp } from "../../MVVM/Hooks/useIsDesktopApp";
import { Subscriptions } from "../../MVVM/Views/ProfileSettings/Subscriptions";
import { ThirdPartySettings } from "MVVM/Views/ProfileSettings/ThirdPartySettings";
import { SteambotSettings } from "MVVM/Views/ProfileSettings/SteambotSettings";
import { analytics } from "MVVM/Analytics";
async function openDesktopApplication(setDesktopAppButton, appToken) {
  await new Promise((resolve) => setTimeout(resolve, 2000));
  const popup_window = window.open(`allstargg://token=${appToken}`);
  try {
    popup_window.focus();
  } catch (e) {
    alert(
      "Pop-up Blocker is enabled, please add this site to your exception list to launch the Allstar Desktop App!",
    );
    setDesktopAppButton(true);
  }
}

function desktopAppBodyContent() {
  return (
    <Body>
      This will take just a moment. You will be redirected back to the app
      momentarily, have fun creating amazing content!
    </Body>
  );
}

export function AccountContent(props) {
  const isDesktopApp = useIsDesktopApp();
  const [view, setView] = useState(props.view);
  const [desktopAppButton, setDesktopAppButton] = useState(false);
  const { allstarUser, getFreshProfile } = useUser();
  const isSticky = useMediaQuery(`(min-width:${theme.breakpoints[2]})`);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const referrer = params.get("referrer");

  const { handleSubmit, register, formState, reset } = useForm();

  useTrackUnsavedChanges({ view, setView, formState, reset });

  const viewMap = {
    accountSettings: (
      <AccountSettings
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
    ),
    clipSettings: <ClipSettings />,
    notifications: <Notifications />,
    subscriptions: <Subscriptions />,
    connectedAccounts: <ConnectedAccounts />,
    thirdPartySettings: (
      <ThirdPartySettings
        handleSubmit={handleSubmit}
        register={register}
        formState={formState}
        reset={reset}
        allstarUser={allstarUser}
      />
    ),
    steambotSettings: <SteambotSettings />,
  };

  const [appToken, setAppToken] = useState();

  useEffect(() => {
    setView(props.view);
  }, [props.view]);

  useEffect(() => {
    if (referrer === "desktop_app") {
      (async function getAppToken() {
        // await CheckExpiry();
        const data = await Axios.get(
          `${
            process.env.REACT_APP_API_URL
          }/items/desktoptoken/@me?token=${localStorage.getItem("token")}`,
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
        setAppToken(data.data.token);

        openDesktopApplication(setDesktopAppButton, data.data.token);
      })();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (referrer === "desktop_app") {
    return (
      <FullScreenWrapper>
        <FloatingContainer>
          <FloatingContent
            title="Logging into Allstar"
            body={desktopAppBodyContent()}
          >
            {desktopAppButton ? (
              <>
                <Box>
                  <ExternalButton
                    onClick={() => {
                      analytics.track("Launch Desktop App From Dashboard");
                    }}
                    href={`allstargg://token=${appToken}`}
                  >
                    Launch Desktop App
                  </ExternalButton>
                </Box>
                <br />
              </>
            ) : null}
            <Box>
              <FormLink to={URLS.SUPPORT}>
                Having trouble? Contact support.
              </FormLink>
            </Box>
          </FloatingContent>
        </FloatingContainer>
      </FullScreenWrapper>
    );
  }

  return (
    <>
      <Flex my={[0, 6]} />
      <Page
        flexDirection={["column", "column", "column", "row"]}
        isDesktop={isDesktopApp.isDesktop}
        style={{ minHeight: "calc(100vh - 486px)" }}
      >
        <StickySideRail
          showOnMobile={true}
          enabled={isSticky}
          view={view}
          offset={51}
        >
          <AccountMenu view={view} setView={setView} />
        </StickySideRail>
        <MainRail pb={8} style={{ maxWidth: 896 }}>
          {viewMap[view]}
        </MainRail>
      </Page>
    </>
  );
}
